module.exports = __webpack_public_path__ + "static/media/onboarding-name.2b7546f3.png";